import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  quantity: z.coerce.number().optional(),
  packageQuantity: z.number(),
  fixedValue: z.boolean(),
  volumes: z.coerce.number().optional(),
  unitaryValue: z
    .string()
    .regex(/^(\d+|\d{1,3}(,\d{3})*(\.\d{1,6})?|\d{1,6}(,\d{1,6})?)$/, {
      message: 'Valor unitário inválido!',
    })
    .refine((value) => Number(value.replace(',', '.')) > 0, {
      message: 'Valor unitário inválido!',
    }),
  discount: z
    .string()
    .regex(/^(\d+|\d{1,3}(,\d{3})*(\.\d{1,6})?|\d{1,6}(,\d{1,6})?)$/, {
      message: 'Desconto inválido!',
    })
    .refine(
      (value) =>
        Number(value.replace(',', '.')) >= 0 &&
        Number(value.replace(',', '.')) < 100,
      {
        message: 'Desconto inválido!',
      },
    ),
})

export type TSchemaValidation = z.infer<typeof schema>

export const schemaValidation = zodResolver(schema)
